import { countryToAlpha2 } from 'country-to-iso';
import { currencyDisplay, getSupportedLocales } from '@/utils/i18n-helpers';
import i18n from '@/i18n';

/**
 * This is a copy of the Salata map and is used in Remy and Linguini as well.
 * Double-check before editing this map.
 */
export const countryToCurrency: Record<string, string> = {
	AD: 'EUR',
	AE: 'AED',
	AF: 'AFN',
	AG: 'XCD',
	AI: 'XCD',
	AL: 'ALL',
	AM: 'AMD',
	AN: 'ANG',
	AO: 'AOA',
	AQ: 'USD',
	AR: 'ARS',
	AS: 'USD',
	AT: 'EUR',
	AU: 'AUD',
	AW: 'AWG',
	AX: 'EUR',
	AZ: 'AZN',
	BA: 'BAM',
	BB: 'BBD',
	BD: 'BDT',
	BE: 'EUR',
	BF: 'XOF',
	BG: 'BGN',
	BH: 'BHD',
	BI: 'BIF',
	BJ: 'XOF',
	BL: 'EUR',
	BM: 'BMD',
	BN: 'BND',
	BO: 'BOB',
	BQ: 'USD',
	BR: 'BRL',
	BS: 'BSD',
	BT: 'BTN',
	BV: 'NOK',
	BW: 'BWP',
	BY: 'BYN',
	BZ: 'BZD',
	CA: 'CAD',
	CC: 'AUD',
	CD: 'CDF',
	CF: 'XAF',
	CG: 'XAF',
	CH: 'CHF',
	CI: 'XOF',
	CK: 'NZD',
	CL: 'CLP',
	CM: 'XAF',
	CN: 'CNY',
	CO: 'COP',
	CR: 'CRC',
	CU: 'CUP',
	CV: 'CVE',
	CW: 'ANG',
	CX: 'AUD',
	CY: 'EUR',
	CZ: 'CZK',
	DE: 'EUR',
	DJ: 'DJF',
	DK: 'DKK',
	DM: 'XCD',
	DO: 'DOP',
	DZ: 'DZD',
	EC: 'USD',
	EE: 'EUR',
	EG: 'EGP',
	EH: 'MAD',
	ER: 'ERN',
	ES: 'EUR',
	ET: 'ETB',
	FI: 'EUR',
	FJ: 'FJD',
	FK: 'FKP',
	FM: 'USD',
	FO: 'DKK',
	FR: 'EUR',
	GA: 'XAF',
	GB: 'GBP',
	GD: 'XCD',
	GE: 'GEL',
	GF: 'EUR',
	GG: 'GBP',
	GH: 'GHS',
	GI: 'GIP',
	GL: 'DKK',
	GM: 'GMD',
	GN: 'GNF',
	GP: 'EUR',
	GQ: 'XAF',
	GR: 'EUR',
	GS: 'FKP',
	GT: 'GTQ',
	GU: 'USD',
	GW: 'XOF',
	GY: 'GYD',
	HK: 'HKD',
	HM: 'AUD',
	HN: 'HNL',
	HR: 'EUR',
	HT: 'HTG',
	HU: 'HUF',
	ID: 'IDR',
	IE: 'EUR',
	IL: 'ILS',
	IM: 'GBP',
	IN: 'INR',
	IO: 'USD',
	IQ: 'IQD',
	IR: 'IRR',
	IS: 'ISK',
	IT: 'EUR',
	JE: 'GBP',
	JM: 'JMD',
	JO: 'JOD',
	JP: 'JPY',
	KE: 'KES',
	KG: 'KGS',
	KH: 'KHR',
	KI: 'AUD',
	KM: 'KMF',
	KN: 'XCD',
	KP: 'KPW',
	KR: 'KRW',
	KW: 'KWD',
	KY: 'KYD',
	KZ: 'KZT',
	LA: 'LAK',
	LB: 'LBP',
	LC: 'XCD',
	LI: 'CHF',
	LK: 'LKR',
	LR: 'LRD',
	LS: 'LSL',
	LT: 'EUR',
	LU: 'EUR',
	LV: 'EUR',
	LY: 'LYD',
	MA: 'MAD',
	MC: 'EUR',
	MD: 'MDL',
	ME: 'EUR',
	MF: 'EUR',
	MG: 'MGA',
	MH: 'USD',
	MK: 'MKD',
	ML: 'XOF',
	MM: 'MMK',
	MN: 'MNT',
	MO: 'MOP',
	MP: 'USD',
	MQ: 'EUR',
	MR: 'MRU',
	MS: 'XCD',
	MT: 'EUR',
	MU: 'MUR',
	MV: 'MVR',
	MW: 'MWK',
	MX: 'MXN',
	MY: 'MYR',
	MZ: 'MZN',
	NA: 'NAD',
	NC: 'XPF',
	NE: 'XOF',
	NF: 'AUD',
	NG: 'NGN',
	NI: 'NIO',
	NL: 'EUR',
	NO: 'NOK',
	NP: 'NPR',
	NR: 'AUD',
	NU: 'NZD',
	NZ: 'NZD',
	OM: 'OMR',
	PA: 'PAB',
	PE: 'PEN',
	PF: 'XPF',
	PG: 'PGK',
	PH: 'PHP',
	PK: 'PKR',
	PL: 'PLN',
	PM: 'EUR',
	PN: 'NZD',
	PR: 'USD',
	PS: 'ILS',
	PT: 'EUR',
	PW: 'USD',
	PY: 'PYG',
	QA: 'QAR',
	RE: 'EUR',
	RO: 'RON',
	RS: 'RSD',
	RU: 'RUB',
	RW: 'RWF',
	SA: 'SAR',
	SB: 'SBD',
	SC: 'SCR',
	SD: 'SDG',
	SE: 'SEK',
	SG: 'SGD',
	SH: 'SHP',
	SI: 'EUR',
	SJ: 'NOK',
	SK: 'EUR',
	SL: 'SLE',
	SM: 'EUR',
	SN: 'XOF',
	SO: 'SOS',
	SR: 'SRD',
	SS: 'SSP',
	ST: 'STN',
	SV: 'USD',
	SX: 'ANG',
	SY: 'SYP',
	SZ: 'SZL',
	TC: 'USD',
	TD: 'XAF',
	TF: 'EUR',
	TG: 'XOF',
	TH: 'THB',
	TJ: 'TJS',
	TK: 'NZD',
	TL: 'USD',
	TM: 'TMT',
	TN: 'TND',
	TO: 'TOP',
	TR: 'TRY',
	TT: 'TTD',
	TV: 'AUD',
	TW: 'TWD',
	TZ: 'TZS',
	UA: 'UAH',
	UG: 'UGX',
	UM: 'USD',
	US: 'USD',
	UY: 'UYU',
	UZ: 'UZS',
	VA: 'EUR',
	VC: 'XCD',
	VE: 'VES',
	VG: 'USD',
	VI: 'USD',
	VN: 'VND',
	VU: 'VUV',
	WF: 'XPF',
	WS: 'WST',
	YE: 'YER',
	YT: 'EUR',
	ZA: 'ZAR',
	ZM: 'ZMW',
	ZW: 'ZWL'
};

const FALLBACK_CURRENCY = 'CAD';

/**
 * Get the alpha-2 country code for a location from its address.
 *
 * @param {string} [address]
 * @return {string|null}
 */
export function getCountryFromAddress(address?: string): string | null {
	try {
		const country = address?.split(',').pop()?.trim();
		return country ? countryToAlpha2(country) : null;
	}
	catch (_error) {
		return null;
	}
}

/**
 * Get the currency code for a location from its alpha-2 country code,
 * mapped through `countryToCurrency` (same logic as Salata).
 *
 * Falls back to `CAD` on any failure: missing country, unmapped code, or a
 * code that Intl cannot format.
 *
 * @param {string|null} [country]
 * @return {string}
 */
export function getCurrencyFromCountry(country?: string | null): string {
	try {
		const code = country ? countryToCurrency[country] : undefined;
		if (!code) {
			return FALLBACK_CURRENCY;
		}
		new Intl.NumberFormat('en', { style: 'currency', currency: code });
		return code;
	}
	catch (_error) {
		return FALLBACK_CURRENCY;
	}
}

/**
 * Resolve the currency symbol and its position for price input fields.
 *
 * @param {string} currency
 * @param {string} locale
 * @return {PriceAffixes} The symbol on the side the locale puts it, the other side empty
 */
export function resolvePriceAffixes(currency: string, locale: string): PriceAffixes {
	const parts = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay }).formatToParts(1);
	const symbolIndex = parts.findIndex((part: Intl.NumberFormatPart) => part.type === 'currency');
	const symbol = symbolIndex > -1 ? parts[symbolIndex].value : '';
	return {
		prefix: symbolIndex === 0 ? symbol : '',
		suffix: symbolIndex > 0 ? symbol : ''
	};
}

/**
 * Apply a currency to the i18n 'currency' number format of every supported
 * locale, so all $n(x, 'currency') call sites render it reactively.
 *
 * @param {string} currency
 * @return {void}
 */
export function applyCurrencyToI18n(currency: string): void {
	getSupportedLocales().forEach((locale: Locale) => {
		i18n.mergeNumberFormat(locale.code, { currency: { style: 'currency', currency, currencyDisplay } });
	});
}
